<div class="details-container" *ngIf="resource">
  <div class="header">
    <button class="back-button" (click)="goBack()" aria-label="Go back">&#8592;</button>
    <h1 class="title">{{ resource.title }}</h1>
    <div class="actions"></div>
  </div>

  <div class="details-content">
    <!-- Video Player or Image Display -->
    <div class="media-container" *ngIf="resource.videoUrl">
      <div class="video-iframe-wrapper">
        <iframe 
          [src]="resource.videoUrl | safeResourceUrl" 
          title="{{ resource.title }}"
          width="100%" 
          height="100%" 
          style="border:none;overflow:hidden" 
          scrolling="no" 
          frameborder="0" 
          allowfullscreen="true" 
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share">
        </iframe>
      </div>
      <div style="margin-top: 12px; text-align: center;">
        <a [href]="resource.videoUrl" target="_blank" rel="noopener noreferrer" class="fb-link-btn">
          Watch on Facebook ↗
        </a>
      </div>
    </div>

    <img *ngIf="!resource.videoUrl && resource.imageUrl" [src]="resource.imageUrl" alt="{{ resource.title }}" class="main-image">

    <div class="content">
      <p class="summary">{{ resource.summary }}</p>
      <div [innerHTML]="resource.body"></div>
    </div>
  </div>
</div>

<div class="details-container error-state" *ngIf="!resource">
  <h2>Resource not found</h2>
  <button class="back-button" (click)="goBack()">&#8592; Go Back</button>
</div>
